import { ClaimTemplate } from 'core/claim';
import { useRevalidation } from 'hooks/useRevalidation';
import { ClaimApi } from 'integration/aggregate';
import { ClaimStackScreenProps } from 'navigation';
import React, { useCallback } from 'react';
import { NotFoundScreen } from 'screens/NotFoundScreen';
import { trpc } from 'trpc';

import { ScreenComponent } from './internal';

const api = new ClaimApi();

export const ClaimScreen: React.FC<ClaimStackScreenProps<'ViewClaims'>> = ({ route }) => {
  const { id } = route.params;

  const {
    data,
    isFetching: isValidating,
    isError: error,
  } = trpc.context.claim.getById.useQuery({ id });

  const revalidate = useRevalidation(id);

  const onSubmit = useCallback(async () => {
    await api.submit(id);
    await revalidate();
  }, [id, revalidate]);

  const onEdit = useCallback(
    async (result: ClaimTemplate) => {
      await api.update({
        id,
        chargeLines: result.claimLines.map(line => ({
          chargeLine: line.chargeItemIdentifier,
          quantity: line.quantity,
        })),
      });
      await revalidate();
    },
    [id, revalidate]
  );

  if (error) {
    return <NotFoundScreen />;
  }

  return (
    <ScreenComponent
      responseData={{ data, isValidating, error }}
      onSubmit={onSubmit}
      onEdit={onEdit}
    />
  );
};
